/* tslint:disable */
/* eslint-disable */
/**
 * Prove Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface DeleteIndexDocIdRequest {
    index: string;
    id: string;
    query?: { [key: string]: string; };
}

export interface DeleteSearchScrollRequest {
    body: string;
    query?: { [key: string]: string; };
}

export interface GetIndexDocIdRequest {
    index: string;
    id: string;
    query?: { [key: string]: string; };
}

export interface GetIndexTypeCountRequest {
    index: string;
    type: string;
    query?: { [key: string]: string; };
}

export interface PostBulkRequest {
    body: string;
    query?: { [key: string]: string; };
}

export interface PostIndexDocRequest {
    index: string;
    body: string;
    query?: { [key: string]: string; };
}

export interface PostIndexDocIdRequest {
    index: string;
    id: string;
    body: string;
    query?: { [key: string]: string; };
}

export interface PostIndexDocIdUpdateRequest {
    index: string;
    id: string;
    body: string;
    query?: { [key: string]: string; };
}

export interface PostIndexSearchRequest {
    index: string;
    body: string;
    query?: { [key: string]: string; };
}

export interface PostIndexTypeBulkRequest {
    index: string;
    type: string;
    body: string;
    query?: { [key: string]: string; };
}

export interface PostIndexTypeCountRequest {
    index: string;
    type: string;
    body: string;
    query?: { [key: string]: string; };
}

export interface PostIndexTypeMultiSearchRequest {
    index: string;
    type: string;
    body: string;
    query?: { [key: string]: string; };
}

export interface PostIndexTypeSearchRequest {
    index: string;
    type: string;
    body: string;
    query?: { [key: string]: string; };
}

export interface PostSearchScrollRequest {
    body: string;
    query?: { [key: string]: string; };
}

export interface PutIndexDocIdRequest {
    index: string;
    id: string;
    body: string;
    query?: { [key: string]: string; };
}

/**
 * 
 */
export class OpenSearchApi extends runtime.BaseAPI {

    /**
     * delete document
     */
    async deleteIndexDocIdRaw(requestParameters: DeleteIndexDocIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling deleteIndexDocId().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteIndexDocId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{index}/_doc/{id}`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * delete document
     */
    async deleteIndexDocId(requestParameters: DeleteIndexDocIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deleteIndexDocIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete search scroll
     */
    async deleteSearchScrollRaw(requestParameters: DeleteSearchScrollRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling deleteSearchScroll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/_search/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * delete search scroll
     */
    async deleteSearchScroll(requestParameters: DeleteSearchScrollRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deleteSearchScrollRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get document
     */
    async getIndexDocIdRaw(requestParameters: GetIndexDocIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling getIndexDocId().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getIndexDocId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{index}/_doc/{id}`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * get document
     */
    async getIndexDocId(requestParameters: GetIndexDocIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getIndexDocIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * count
     */
    async getIndexTypeCountRaw(requestParameters: GetIndexTypeCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling getIndexTypeCount().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling getIndexTypeCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/{index}/{type}/_count`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * count
     */
    async getIndexTypeCount(requestParameters: GetIndexTypeCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getIndexTypeCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * multiple index/update/delete
     */
    async postBulkRaw(requestParameters: PostBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling postBulk().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/_bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * multiple index/update/delete
     */
    async postBulk(requestParameters: PostBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create and update document
     */
    async postIndexDocRaw(requestParameters: PostIndexDocRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling postIndexDoc().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling postIndexDoc().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/{index}/_doc`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * create and update document
     */
    async postIndexDoc(requestParameters: PostIndexDocRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postIndexDocRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create and update document
     */
    async postIndexDocIdRaw(requestParameters: PostIndexDocIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling postIndexDocId().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling postIndexDocId().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling postIndexDocId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/{index}/_doc/{id}`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * create and update document
     */
    async postIndexDocId(requestParameters: PostIndexDocIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postIndexDocIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update document
     */
    async postIndexDocIdUpdateRaw(requestParameters: PostIndexDocIdUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling postIndexDocIdUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling postIndexDocIdUpdate().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling postIndexDocIdUpdate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/{index}/_doc/{id}/_update`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * update document
     */
    async postIndexDocIdUpdate(requestParameters: PostIndexDocIdUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postIndexDocIdUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * search
     */
    async postIndexSearchRaw(requestParameters: PostIndexSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling postIndexSearch().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling postIndexSearch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/{index}/_search`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * search
     */
    async postIndexSearch(requestParameters: PostIndexSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postIndexSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * bulk
     */
    async postIndexTypeBulkRaw(requestParameters: PostIndexTypeBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling postIndexTypeBulk().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling postIndexTypeBulk().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling postIndexTypeBulk().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/{index}/{type}/_bulk`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * bulk
     */
    async postIndexTypeBulk(requestParameters: PostIndexTypeBulkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postIndexTypeBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * count
     */
    async postIndexTypeCountRaw(requestParameters: PostIndexTypeCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling postIndexTypeCount().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling postIndexTypeCount().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling postIndexTypeCount().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/{index}/{type}/_count`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * count
     */
    async postIndexTypeCount(requestParameters: PostIndexTypeCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postIndexTypeCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * multi-search
     */
    async postIndexTypeMultiSearchRaw(requestParameters: PostIndexTypeMultiSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling postIndexTypeMultiSearch().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling postIndexTypeMultiSearch().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling postIndexTypeMultiSearch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/{index}/{type}/_msearch`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * multi-search
     */
    async postIndexTypeMultiSearch(requestParameters: PostIndexTypeMultiSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postIndexTypeMultiSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * search
     */
    async postIndexTypeSearchRaw(requestParameters: PostIndexTypeSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling postIndexTypeSearch().'
            );
        }

        if (requestParameters['type'] == null) {
            throw new runtime.RequiredError(
                'type',
                'Required parameter "type" was null or undefined when calling postIndexTypeSearch().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling postIndexTypeSearch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/{index}/{type}/_search`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));
        urlPath = urlPath.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters['type'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * search
     */
    async postIndexTypeSearch(requestParameters: PostIndexTypeSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postIndexTypeSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * allow search scroll
     */
    async postSearchScrollRaw(requestParameters: PostSearchScrollRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling postSearchScroll().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/_search/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * allow search scroll
     */
    async postSearchScroll(requestParameters: PostSearchScrollRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.postSearchScrollRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create and update document
     */
    async putIndexDocIdRaw(requestParameters: PutIndexDocIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['index'] == null) {
            throw new runtime.RequiredError(
                'index',
                'Required parameter "index" was null or undefined when calling putIndexDocId().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling putIndexDocId().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling putIndexDocId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/{index}/_doc/{id}`;
        urlPath = urlPath.replace(`{${"index"}}`, encodeURIComponent(String(requestParameters['index'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * create and update document
     */
    async putIndexDocId(requestParameters: PutIndexDocIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.putIndexDocIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
